export const getLocaleIdentifierFromLocaleCookie = (localeCookie: string) => {
  return `${localeCookie}-de`;
};

export const getLocaleCookieFromLocaleIdentifier = (locale: Locale) =>
  locale.split('-')[0];

export const getRegionCookieFromLocaleIdentifier = (locale: Locale) =>
  locale.split('-')[1];
